
import request from '../util/request'

export function getQiniuToken() {
  return request({
    url: 'admin/getQiniuToken',
    method: 'get'
  })
}

export function operationData(data,url){
  return request({
    url: url,
    method: 'post',
    data:data
  })
}

export function getStatistics(data){
  return request({
    url: 'statistics',
    method: 'post',
    data:data
  })
}

export function ourTeam(data) {
  return request({
    url: 'ourTeam',
    method: 'post',
    data:data
  })
}


export function getRooms(data) {
  return request({
    url: 'getRooms',
    method: 'post',
    data:data
  })
}


export function getStores(data) {
  return request({
    url: 'getStores',
    method: 'post',
    data:data
  })
}

export function getRoomDate(data) {
  return request({
    url: 'getRoomDate',
    method: 'post',
    data:data
  })
}

export function getOrderDetailData(data) {
  return request({
    url: 'getOrderDetail',
    method: 'post',
    data:data
  })
}

/**
 * 移动端房态详情（h5.vue / client.vue 专用）
 * 字段名：customers / staff / contact / orders_meeting_room / added_services
 * 注意：不能复用 getOrderDetailData —— 后者走 admin 应用返回的是
 * customer_text / staff_text / rooms_text 口径，pc.vue 与 title.vue 依赖它。
 */
export function getClientOrderDetailData(data) {
  return request({
    url: 'client/getOrderDetail',
    method: 'post',
    data:data
  })
}

export function getDanamicJoinData(data) {
  return request({
    url: 'dynamicJoin',
    method: 'post',
    data:data
  })
}

export function getCalculateTotalData(data) {
  return request({
    url: 'calculateTotal',
    method: 'post',
    data:data
  })
}


export function getStores2Data(data) {
  return request({
    url: 'getStoresCalculate',
    method: 'post',
    data:data
  })
}

export function getRooms2Data(data) {
  return request({
    url: 'getRoomsCalculate',
    method: 'post',
    data:data
  })
}

export function getConfigStatistics(data) {
  return request({
    url: 'getConfigStatistics',
    method: 'post',
    data:data
  })
}


export function getExportRoomOrder(data){
  return request({
    url: 'exportRoomOrderTotal',
    method: 'post',
    data:data
  })
}

export function getExportContracts(data){
  return request({
    url: 'exportContractsTotal',
    method: 'post',
    data:data
  })
}

export function getExportTarget(data){
  return request({
    url: 'exportTargetTotal',
    method: 'post',
    data:data
  })
}


export function getCustomersListData(data){
  return request({
    url: 'client/customersList',
    method: 'post',
    data:data
  })
}

export function getLogListData(data){
  return request({
    url: 'client/logList',
    method: 'post',
    data:data
  })
}

export function getManagedStaffData(data){
  return request({
    url: 'client/getManagedStaff',
    method: 'post',
    data:data
  })
}



export function getOpportunitiesListData(data){ 
  return request({ 
    url: 'client/opportunitiesList',
    method: 'post',
    data:data
  })
}

export function getOpportunitiesStatData(data){ 
  return request({ 
    url: 'client/opportunitiesStat',
    method: 'post',
    data:data
  })
}

export function getContractsStatData(data){ 
  return request({ 
    url: 'client/contractsStat',
    method: 'post',
    data:data
  })
}

export function getOrdersStatData(data){ 
  return request({ 
    url: 'client/ordersStat',
    method: 'post',
    data:data
  })
}

export function getStatisticsDashboardData(data){ 
  return request({ 
    url: 'client/statisticsDashboard',
    method: 'post',
    data:data
  })
}

export function getContractFlowData(data){ 
  return request({ 
    url: 'client/contractFlow',
    method: 'post',
    data:data
  })
}

export function getContractFlowDetailData(data){ 
  return request({ 
    url: 'client/contractFlowDetail',
    method: 'post',
    data:data
  })
}


export function getOrdersListData(data){
  return request({
    url: 'client/ordersList',
    method: 'post',
    data:data
  })
}

export function getMessageListData(data){
  return request({
    url: 'client/messageList',
    method: 'post',
    data:data
  })
}

//客户表单选项：类别 / 状态 / 行业 / 来源
export function getCustomersOptionData(data){
  return request({
    url: 'client/customersOption',
    method: 'post',
    data:data
  })
}

//客户详情：编辑回填
export function getCustomersDetailData(data){
  return request({
    url: 'client/customersDetail',
    method: 'post',
    data:data
  })
}

//客户保存：新增 / 编辑
export function saveCustomersData(data){
  return request({
    url: 'client/customersSave',
    method: 'post',
    data:data
  })
}

/* ==================== 【P439】客户删除 / 回收站 ==================== */
//删除客户前预检：名下商机/合同/发票/会议室订单/联系人/回访数量
export function customersDeletePrecheck(data){
  return request({
    url: 'client/customersDeletePrecheck',
    method: 'post',
    data:data
  })
}

//删除客户（移入回收站，关联单据不动）
export function customersDelete(data){
  return request({
    url: 'client/customersDelete',
    method: 'post',
    data:data
  })
}

//回收站列表（搜索 + 分页）
export function customersRecycleList(data){
  return request({
    url: 'client/customersRecycleList',
    method: 'post',
    data:data
  })
}

//回收站：恢复客户
export function customersRecycleRestore(data){
  return request({
    url: 'client/customersRecycleRestore',
    method: 'post',
    data:data
  })
}

//回收站：彻底删除（force=1 才忽略关联单据拦截）
export function customersRecyclePurge(data){
  return request({
    url: 'client/customersRecyclePurge',
    method: 'post',
    data:data
  })
}

//联系人新增（归属客户）
export function saveContactData(data){
  return request({
    url: 'client/contactSave',
    method: 'post',
    data:data
  })
}

//回访记录新增（归属客户）
export function saveVisitData(data){
  return request({
    url: 'client/visitSave',
    method: 'post',
    data:data
  })
}

//联系人删除（软删除）
export function deleteContactData(data){
  return request({
    url: 'client/contactDelete',
    method: 'post',
    data:data
  })
}

//回访记录删除（软删除）
export function deleteVisitData(data){
  return request({
    url: 'client/visitDelete',
    method: 'post',
    data:data
  })
}

//客户分配：销售 接收 / 拒绝（移动端单条 + 批量）
export function customerAllocationAction(data){
  return request({
    url: 'client/customerAllocationAction',
    method: 'post',
    data:data
  })
}

//客户分配：销售管理员 批量分配给下属销售
export function customerAllocationBatch(data){
  return request({
    url: 'client/customerAllocationBatch',
    method: 'post',
    data:data
  })
}

//商机详情：编辑回填
export function getOpportunitiesDetailData(data){
  return request({
    url: 'client/opportunitiesDetail',
    method: 'post',
    data:data
  })
}

//商机保存：新增 / 编辑
export function saveOpportunitiesData(data){
  return request({
    url: 'client/opportunitiesSave',
    method: 'post',
    data:data
  })
}

//商机阶段时间线
export function getOpportunitiesStageListData(data){
  return request({
    url: 'client/opportunitiesStageList',
    method: 'post',
    data:data
  })
}

//商机删除
export function deleteOpportunitiesData(data){
  return request({
    url: 'client/opportunitiesDelete',
    method: 'post',
    data:data
  })
}

//合同详情：编辑回填
export function getOrdersDetailData(data){
  return request({
    url: 'client/ordersDetail',
    method: 'post',
    data:data
  })
}

//合同保存：新增 / 编辑
export function saveOrdersData(data){
  return request({
    url: 'client/ordersSave',
    method: 'post',
    data:data
  })
}

// 【P95】三.00 销售合同审批：action = pass | reject（remark 为驳回原因）
export function ordersApprovalData(data){
  return request({
    url: 'client/ordersApproval',
    method: 'post',
    data:data
  })
}

// 【P95】三.1.01 销售合同删除（仅合同负责人可删，后端强校验）
export function deleteOrdersData(data){
  return request({
    url: 'client/ordersDelete',
    method: 'post',
    data:data
  })
}

// ============================================================
// 会议室订单（client/roomOrder）H5 新增/列表/编辑/删除
// ============================================================
export function getRoomOrderListData(data){
  return request({ url: 'client/roomOrder/getListData', method: 'post', data:data })
}
export function getRoomOrderFormData(data){
  return request({ url: 'client/roomOrder/getFormData', method: 'post', data:data })
}
export function getRoomOrderDetailData(data){
  return request({ url: 'client/roomOrder/getDetailData', method: 'post', data:data })
}
export function saveRoomOrderData(data){
  return request({ url: 'client/roomOrder/save', method: 'post', data:data })
}
export function deleteRoomOrderData(data){
  return request({ url: 'client/roomOrder/delete', method: 'post', data:data })
}

// ============================================================
// 合同详情独立页（PC）：各 tab 列表接口占位
// 后端需按实际路由补充；当前前端页面已预留调用与列表结构
// ============================================================

// 会议室预订单
export function getContractRoomOrderListData(data){
  return request({
    url: 'client/orderRoomOrderList',
    method: 'post',
    data:data
  })
}
// 【P321】支付单「关联会议室订单」分页列表（详情页全屏弹窗用，读 name 字段）
export function getPaymentRoomListData(data){
  return request({
    url: 'client/paymentRoomList',
    method: 'post',
    data:data
  })
}

// 【P108】「我是否管理人员」= 管理员 ∪ 部门负责人 ∪ 任一单据 position=1 管理者
//   用于「删除」等管理类入口的显隐（与后端 _canManageDelete 同源）
/* 【P114】销售端本人画像（名称 / 部门 / 角色）—— 快捷入口头部展示用
   对齐 market/myProfile 与 finance/myProfile 的出参口径 */
export function getMyProfileData(data){
  return request({
    url: 'client/myProfile',
    method: 'post',
    data: data || {}
  })
}

export function isManagerData(data){
  return request({
    url: 'client/isManager',
    method: 'post',
    data: data || {}
  })
}

// 【P107】会议室订单「被驳回」气泡：{ count, sns }
//   口径 = pro_orders_meeting_room.status=2 且 is_delete=0（重新送审后 room.status 回到 0，气泡自然消失）
export function roomOrderRejectBadgeData(data){
  return request({
    url: 'client/roomOrderRejectBadge',
    method: 'post',
    data: data || {}
  })
}

// 会议室预订单-下拉选项（会议室列表，合同详情添加弹窗用）
export function getContractRoomOptionsData(data){
  return request({
    url: 'client/orderRoomOptions',
    method: 'post',
    data:data || {}
  })
}

// 会议室预订单-表单选项（会议室含分时段价格 / 客户 / 商机 / 门店 / 合同）
export function getContractRoomFormOptionsData(data){
  return request({
    url: 'client/orderRoomFormOptions',
    method: 'post',
    data:data || {}
  })
}

// 增值服务订单
export function getContractAddedServiceListData(data){
  return request({
    url: 'client/orderAddedServiceList',
    method: 'post',
    data:data
  })
}

// 支付单
export function getContractPaymentListData(data){
  return request({
    url: 'client/orderPaymentList',
    method: 'post',
    data:data
  })
}

// 【P9】财务部门人员列表（支付单审批人下拉；默认陈凯蕾置顶）
export function getFinanceStaffListData(data){
  return request({
    url: 'client/orderFinanceStaffList',
    method: 'post',
    data: data || {}
  })
}

// 【P24-5】支付单筛选：受理人（财务人员）下拉选项
export function getPaymentOwnerOptions(data){
  return request({
    url: 'client/orderPaymentOwnerOptions',
    method: 'post',
    data: data || {}
  })
}

// 【P24-5】支付单筛选：支付方式/支付类型/支付产品/状态 字典
export function getPaymentFilterOptions(data){
  return request({
    url: 'client/orderPaymentFilterOptions',
    method: 'post',
    data: data || {}
  })
}

// 【P9】本销售合同已有财务合同选项（category=payment_product 过滤；空=首次回款走审批后自动创建）
export function getFinanceContractOptionsData(data){
  return request({
    url: 'client/orderFinanceContractOptions',
    method: 'post',
    data: data || {}
  })
}

// 【P13-R2】退款单 method=3 转移目标选项（同客户其他非充值销售合同，最新在前，最多5个）
export function getRefundTransferOptionsData(data){
  return request({
    url: 'client/orderRefundTransferOptions',
    method: 'post',
    data: data || {}
  })
}

// 支付单图片：本地单张上传（非七牛），返回可访问 URL
export function uploadPaymentImage(data){
  return request({
    url: 'client/orderPaymentUpload',
    method: 'post',
    data: data
  })
}

// 回款计划
export function getContractCollectionListData(data){
  return request({
    url: 'client/orderCollectionList',
    method: 'post',
    data:data
  })
}

// 余额明细
export function getContractBalanceListData(data){
  return request({
    url: 'client/orderBalanceList',
    method: 'post',
    data:data
  })
}

// 财务合同
export function getContractFinanceContractListData(data){
  return request({
    url: 'client/orderFinanceContractList',
    method: 'post',
    data:data
  })
}

// 【P16】财务合同详情聚合（基本信息 + 关联会议室/回款单/发票/退款记录）
export function getFinanceContractDetailData(data){
  return request({
    url: 'client/orderFinanceContractDetail',
    method: 'post',
    data:data
  })
}

// 财务发票
export function getContractInvoiceListData(data){
  return request({
    url: 'client/orderInvoiceList',
    method: 'post',
    data:data
  })
}

// 退款单
export function getContractRefundListData(data){
  return request({
    url: 'client/orderRefundList',
    method: 'post',
    data:data
  })
}

// 审批
export function getContractApprovalListData(data){
  return request({
    url: 'client/orderApprovalList',
    method: 'post',
    data:data
  })
}

// ============================================================
// 合同详情单据页：编辑 / 删除（新增见上方 *Save）
// 后端 _contractTabEditEx / _contractTabDeleteEx，sn 传单据自身编号
// ============================================================

// 增值服务订单
export function saveContractAddedServiceEditData(data){
  return request({
    url: 'client/orderAddedServiceEdit',
    method: 'post',
    data:data
  })
}
export function saveContractAddedServiceDeleteData(data){
  return request({
    url: 'client/orderAddedServiceDelete',
    method: 'post',
    data:data
  })
}

// 支付单
export function saveContractPaymentEditData(data){
  return request({
    url: 'client/orderPaymentEdit',
    method: 'post',
    data:data
  })
}
export function saveContractPaymentDeleteData(data){
  return request({
    url: 'client/orderPaymentDelete',
    method: 'post',
    data:data
  })
}

// 回款计划
export function saveContractCollectionEditData(data){
  return request({
    url: 'client/orderCollectionEdit',
    method: 'post',
    data:data
  })
}
export function saveContractCollectionDeleteData(data){
  return request({
    url: 'client/orderCollectionDelete',
    method: 'post',
    data:data
  })
}

// 余额明细
export function saveContractBalanceEditData(data){
  return request({
    url: 'client/orderBalanceEdit',
    method: 'post',
    data:data
  })
}
export function saveContractBalanceDeleteData(data){
  return request({
    url: 'client/orderBalanceDelete',
    method: 'post',
    data:data
  })
}

// 财务合同
export function saveContractFinanceContractEditData(data){
  return request({
    url: 'client/orderFinanceContractEdit',
    method: 'post',
    data:data
  })
}
export function saveContractFinanceContractDeleteData(data){
  return request({
    url: 'client/orderFinanceContractDelete',
    method: 'post',
    data:data
  })
}

// 财务发票
export function saveContractInvoiceEditData(data){
  return request({
    url: 'client/orderInvoiceEdit',
    method: 'post',
    data:data
  })
}
export function saveContractInvoiceDeleteData(data){
  return request({
    url: 'client/orderInvoiceDelete',
    method: 'post',
    data:data
  })
}

// 退款单
export function saveContractRefundEditData(data){
  return request({
    url: 'client/orderRefundEdit',
    method: 'post',
    data:data
  })
}
export function saveContractRefundDeleteData(data){
  return request({
    url: 'client/orderRefundDelete',
    method: 'post',
    data:data
  })
}

// 审批
export function saveContractApprovalEditData(data){
  return request({
    url: 'client/orderApprovalEdit',
    method: 'post',
    data:data
  })
}
export function saveContractApprovalDeleteData(data){
  return request({
    url: 'client/orderApprovalDelete',
    method: 'post',
    data:data
  })
}

// ============================================================
// 合同详情独立页（H5）：各 tab 新增保存接口占位
// 后端需按实际路由补充；当前前端页面已预留调用
// ============================================================

// 会议室预订单-新增
export function saveContractRoomOrderData(data){
  return request({
    url: 'client/orderRoomOrderSave',
    method: 'post',
    data:data
  })
}

// 会议室预订单-编辑（按 sn 更新）
export function saveContractRoomOrderEditData(data){
  return request({
    url: 'client/orderRoomOrderEdit',
    method: 'post',
    data:data
  })
}

// 会议室预订单-删除（软删除）
export function saveContractRoomOrderDeleteData(data){
  return request({
    url: 'client/orderRoomOrderDelete',
    method: 'post',
    data:data
  })
}

// 增值服务订单-新增
export function saveContractAddedServiceData(data){
  return request({
    url: 'client/orderAddedServiceSave',
    method: 'post',
    data:data
  })
}

// 支付单-新增
export function saveContractPaymentData(data){
  return request({
    url: 'client/orderPaymentSave',
    method: 'post',
    data:data
  })
}

// 回款计划-新增
export function saveContractCollectionData(data){
  return request({
    url: 'client/orderCollectionSave',
    method: 'post',
    data:data
  })
}

// 余额明细-新增
export function saveContractBalanceData(data){
  return request({
    url: 'client/orderBalanceSave',
    method: 'post',
    data:data
  })
}

// 财务合同-新增
export function saveContractFinanceContractData(data){
  return request({
    url: 'client/orderFinanceContractSave',
    method: 'post',
    data:data
  })
}

// 财务发票-新增
export function saveContractInvoiceData(data){
  return request({
    url: 'client/orderInvoiceSave',
    method: 'post',
    data:data
  })
}

// 退款单-新增
export function saveContractRefundData(data){
  return request({
    url: 'client/orderRefundSave',
    method: 'post',
    data:data
  })
}

// 审批-新增
export function saveContractApprovalData(data){
  return request({
    url: 'client/orderApprovalSave',
    method: 'post',
    data:data
  })
}

// ============================================================
// 【P92】全站单据列表统一引擎（8 类共用同一契约）
//   会议室订单 room / 增值业务订单 value / 支付订单 payment / 回款订单 collection
//   余额明细 balance / 财务合同 contract / 财务发票 invoice / 退款单 refund
//   入参：bill_type + scope(contract|self|dept|all) + sn + page + pageSize + searchText + 各类筛选
//   响应：{ code, msg, data:{ data:[], total, per_page, current_page, last_page, scope } }
// ============================================================
function billReq(prefix, url, data){
  return request({ url: prefix + '/' + url, method: 'post', data: data || {} })
}
// 销售端
export function getBillListData(data){ return billReq('client', 'billList', data) }
export function getBillSumData(data){ return billReq('client', 'billSum', data) }
export function getBillTypesData(data){ return billReq('client', 'billTypes', data) }
// 【P95-B4 四.1.006】单据筛选用「可搜索选择器」数据源
//   kind = customer | opportunity | sales_contract | finance_contract
//   响应：{ code, msg, data:{ list:[{ value, text, sub }] } }
export function getBillFilterOptionsData(data){ return billReq('client', 'billFilterOptions', data) }
// 财务端（全量）
export function getFinanceBillListData(data){ return billReq('finance', 'billList', data) }
export function getFinanceBillSumData(data){ return billReq('finance', 'billSum', data) }
export function getFinanceBillTypesData(data){ return billReq('finance', 'billTypes', data) }
// 市场端（全量只读）
export function getMarketBillListData(data){ return billReq('market', 'billList', data) }
export function getMarketBillSumData(data){ return billReq('market', 'billSum', data) }
export function getMarketBillTypesData(data){ return billReq('market', 'billTypes', data) }
/* 【P419】市场端筛选「可搜索选择器」数据源（客户/商机/销售合同/财务合同）。
 *   此前市场端没有这条路由，只能借 client/billFilterOptions，而 client 内部按「本人归属」
 *   收敛 ⇒ 市场人员筛选器里选项恒空。新路由委托 client 同名方法且 _marketAll=true（全量口径）。 */
export function getMarketBillFilterOptionsData(data){ return billReq('market', 'billFilterOptions', data) }
// 运营端（全量；app/operation 独立应用）
export function getOperationBillListData(data){ return billReq('operation', 'billList', data) }
export function getOperationBillSumData(data){ return billReq('operation', 'billSum', data) }
export function getOperationBillTypesData(data){ return billReq('operation', 'billTypes', data) }
/* 【P418】运营端筛选「可搜索选择器」数据源（客户/商机/销售合同/财务合同）。
 *   为何不能复用 client/billFilterOptions：那条路径内部收敛到「本人归属」，
 *   运营人员名下通常没有客户/商机 ⇒ 恒返回空数组，筛选器等于没有。
 *   本接口为全量口径（与 operation/billList 的 forceAll=true 一致）。 */
export function getOperationBillFilterOptionsData(data){ return billReq('operation', 'billFilterOptions', data) }

// ============================================================
// 【P93】运营端专属接口（app/operation）
//   房态 / 会议室订单待办推送（一级）+ 逐级抄送（二级）/ 完成服务闭环 / 消息中心
// ============================================================
function opReq(url, data){
  return request({ url: 'operation/' + url, method: 'post', data: data || {} })
}
export function operationMyProfile(data){ return opReq('myProfile', data) }
export function operationDashboard(data){ return opReq('dashboard', data) }
export function operationRoomStatus(data){ return opReq('roomStatus', data) }
// 【P169】运营端房态族（与销售端 client 同源：委托 admin:StatisticsRoomController）
export function operationGetRoomDate(data){ return opReq('getRoomDate', data) }
export function operationGetStores(data){ return opReq('getStores', data) }
export function operationGetRooms(data){ return opReq('getRooms', data) }
export function operationRoomOrderList(data){ return opReq('roomOrderList', data) }
export function operationRoomOrderSum(data){ return opReq('roomOrderSum', data) }
export function operationRoomOrderDetail(data){ return opReq('roomOrderDetail', data) }
// 一级推送（单条：sn / 批量：sns）
export function operationRoomTodoPush(data){ return opReq('roomTodoPush', data) }
// 接收人链自检（逐级上行预览）
export function operationRoomReceiverPreview(data){ return opReq('roomReceiverPreview', data) }
// 【P232】确认待办（我知道了）→ 知会运营部门负责人；单条 sn / 批量 sns 同一入口
export function operationRoomTodoConfirm(data){ return opReq('roomTodoConfirm', data) }
// 闭环：完成服务（订单 + 销售合同）
export function operationRoomFinishService(data){ return opReq('roomFinishService', data) }
export function operationRoomBatchFinish(data){ return opReq('roomBatchFinish', data) }
// 【新功能】终态：标记完成（服务人数 + 备注）
export function operationRoomComplete(data){ return opReq('roomComplete', data) }
// 采购单
export function operationPurchaseList(data){ return opReq('purchaseList', data) }
export function operationPurchaseSum(data){ return opReq('purchaseSum', data) }
// 消息中心
export function operationMessageList(data){ return opReq('messageList', data) }
/* 【P240】消息四类计数：待确认 / 已确认 / 未读 / 抄送（前端胶囊角标） */
export function operationMessageSummary(data){ return opReq('messageSummary', data) }
export function operationMessageUnread(data){ return opReq('messageUnread', data) }
export function operationMessageRead(data){ return opReq('messageRead', data) }
export function operationMessageReadAll(data){ return opReq('messageReadAll', data) }

/* ===== 【P105】销售合同审核列表（单条 + 批量同一接口） ===== */
// 审核列表：order_sn（可选，限定单个合同）/ status（默认 2=等待审核，传 all 不过滤）/ keyword / page / limit
export function contractApprovalListData(data){
  return request({
    url: 'client/contractApprovalList',
    method: 'post',
    data: data
  })
}

/* 【P281】运营端消息批量操作三件套
 *   · confirm：批量「我知道了」—— 后端已含 owner 越权校验（只能操作自己的订单）
 *   · delete ：批量删除（★物理删除，按需求不用软删除）
 *   · read   ：批量已读（按勾选逐条置，参考销售端语义）
 */
export function operationMessageConfirmBatch(data){
  return request({
    url: 'operation/messageConfirmBatch',
    method: 'post',
    data: data || {}
  })
}

export function operationMessageDeleteBatch(data){
  return request({
    url: 'operation/messageDeleteBatch',
    method: 'post',
    data: data || {}
  })
}

export function operationMessageReadBatch(data){
  return request({
    url: 'operation/messageReadBatch',
    method: 'post',
    data: data || {}
  })
}

/* 【P400】★ 批量「我知道了」（消息 sn 入参 / 订单维度执行）
 *
 * 用户 10-20：「运营端【待处理】列表选择：批量确认等价于房态详情页里的「我知道了」，
 *   只是由单条操作改为批量操作。需要打通该接口；当前该功能存在异常，
 *   需要修复，将批量确认逻辑修正为「我知道了」的逻辑。」
 *
 * 与 operationMessageConfirmBatch 的区别（别再混用）：
 *   · operationMessageConfirmBatch —— 消息维度简化版，只置 service_status=2 + is_action=1，
 *     缺 stage 推进 / service_finish_* / markApprovalDone / upwardHeads 四个副作用。
 *   · operationMessageTodoConfirmBatch ← 本接口 —— 后端把消息 sn 反解成订单 sn 后
 *     **直接调 OperationPushService::confirmTodo**，与房态详情页「我知道了」同一函数。
 *     入参仍是消息 sn（sns），所以前端不需要自己解析订单 sn。 */
export function operationMessageTodoConfirmBatch(data){
  return opReq('messageTodoConfirmBatch', data)
}
// 气泡：待我处理的合同审核数（order_sn 可选）
export function contractApprovalBadgeData(data){
  return request({
    url: 'client/contractApprovalBadge',
    method: 'post',
    data: data
  })
}
// 审核操作：approval_sns=逗号分隔的审批单 sn，action=pass|reject，remark=驳回原因
export function contractApprovalDoData(data){
  return request({
    url: 'client/contractApprovalDo',
    method: 'post',
    data: data
  })
}

/* 【P130】消息已读上报 */
export function messageReadData(data){
    return request({ url: 'client/messageRead', method: 'post', data: data })
}
export function messageReadAllData(){
    return request({ url: 'client/messageReadAll', method: 'post', data: {} })
}
/* 【P247】「未读」Tab 批量标记已读 */
export function messageReadBatchData(data){
    return request({ url: 'client/messageReadBatch', method: 'post', data: data })
}
/* 【P247】「全部」Tab 批量删除（软删 + 后端归属校验） */
export function messageDeleteData(data){
    return request({ url: 'client/messageDelete', method: 'post', data: data })
}



// WEBPACK FOOTER //
// ./src/api/api.js